/**
 * Creates a new object with all string values prefixed
 * @param obj The object to prefix values for
 * @param prefix The prefix to add to each string value
 * @returns A new object with prefixed values
 */
export function prefixObjectValues<T extends Record<string, string>>(obj: T, prefix: string): T {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    acc[key as keyof T] = `${prefix}-${value}` as any;
    return acc;
  }, {} as T);
}
